import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"justify-content":"center"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("zoom ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "+", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("zoom ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "-", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("small", null, " Klik + pohyb = posunutí času, Ctrl + Klik + pohyb = zoom, Kolečko myši = zoom ")
], -1)
const _hoisted_10 = { class: "tableFixHead" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { style: {"padding":"10px"} }, "Datum/Čas", -1)
const _hoisted_13 = { style: {"padding":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.propVybranaStanice != null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.propVybranaStanice.jmeno), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.bGrafVidet = !_ctx.bGrafVidet;}),
        class: "button",
        style: {"margin":"0 0 0 20px"}
      }, _toDisplayString(_ctx.bGrafVidet ? "Tabulka" : "Graf"), 1)
    ]),
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.flagloaded)
        ? (_openBlock(), _createBlock(_component_LineChart, {
            key: 0,
            ref: "lineRef",
            chartData: _ctx.krivkyData,
            options: _ctx.options,
            style: {"height":"80vh"}
          }, null, 8, ["chartData", "options"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
        }, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
        }, _hoisted_8),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.zoomReset && _ctx.zoomReset(...args)))
        }, "zoom reset"),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.msg), 1)
        ]),
        _hoisted_9
      ])
    ], 512), [
      [_vShow, _ctx.bGrafVidet]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propVybranaStanice?.graph, (column) => {
              return (_openBlock(), _createElementBlock("th", {
                style: {"padding":"10px"},
                scope: "col",
                key: column.signame
              }, _toDisplayString(column.signame), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrTable, (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row[0]
            }, [
              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.MujTimeFormat(row[0])), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row[1], (column) => {
                return (_openBlock(), _createElementBlock("td", {
                  style: {"padding":"10px"},
                  key: column
                }, _toDisplayString(column), 1))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.bGrafVidet]
    ])
  ], 64))
}